import {
  EditorState,
  parsePlainText,
  parseState,
  serializeState,
} from '@justgiving/rich-editor';
import { BLANK_RICHEDITOR_STATE } from '../consts';
import replaceBase64ImageWithGuid from './richTextEditor/replaceBase64ImageWithGuid';
import { StoryType, Story } from '../../types/graphql';

const mapStory = async (story: any) => {
  if (
    !story ||
    JSON.stringify(story) === JSON.stringify(BLANK_RICHEDITOR_STATE)
  ) {
    return null;
  }

  const storyBody = await replaceBase64ImageWithGuid(story);
  return serializeState(storyBody);
};

export default mapStory;

export function parseStory(story?: Story | null): EditorState {
  if (story?.type === StoryType.RichStoryV1Json && story.content) {
    return parseState(story.content);
  }

  if (story?.type === StoryType.Plaintext && story.content) {
    return parsePlainText(story.content);
  }

  return parsePlainText('');
}
